module.exports = __webpack_public_path__ + "media/images/icons/trash-f440d12716a60f157291001045fd33af.svg";